import React, { useState } from 'react';

function TherapySpecialtiesSection() {
  const specialties = [
    {
      title: 'Individual Therapy',
      description: 'One-on-one sessions for personal growth and healing',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      color: 'bg-[#9dacff]'
    },
    {
      title: 'Couples Counseling',
      description: 'Strengthen relationships and improve communication',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: 'bg-[#254e70]'
    },
    {
      title: 'Family Therapy',
      description: 'Build stronger family bonds and resolve conflicts',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      color: 'bg-[#9dacff]'
    },
    {
      title: 'Teen & Adolescent',
      description: 'Specialized support for young people and teens',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      color: 'bg-[#254e70]'
    },
    {
      title: 'Trauma Therapy',
      description: 'Healing from trauma with specialized approaches',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      color: 'bg-[#9dacff]'
    },
    {
      title: 'Anxiety & Depression',
      description: 'Evidence-based treatment for mood disorders',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      ),
      color: 'bg-[#254e70]'
    },
    {
      title: 'LGBTQ+ Support',
      description: 'Affirming therapy for LGBTQ+ individuals',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      color: 'bg-[#9dacff]'
    },
    {
      title: 'Addiction Recovery',
      description: 'Support for substance abuse and addiction',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      color: 'bg-[#254e70]'
    },
    {
      title: 'Grief Counseling',
      description: 'Support through loss and bereavement',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: 'bg-[#254e70]'
    },
    {
      title: 'Eating Disorders',
      description: 'Specialized treatment for eating and body image',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: 'bg-[#9dacff]'
    }
  ];

  // Duplicate the array for seamless looping
  const duplicatedSpecialties = [...specialties, ...specialties];

  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-slate-50 to-blue-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-medium text-[#254e70] mb-6">
            Therapy for Every Need
          </h2>
          <p className="text-lg lg:text-xl text-[#254e70]/70 max-w-3xl mx-auto">
            Our network of licensed therapists offers specialized care across a wide range of mental health areas.
          </p>
        </div>
      </div>

      {/* Scrolling Bar Container - Full Width */}
      <div className="relative w-full">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-blue-50 to-transparent z-10 pointer-events-none"></div>
        
        {/* Scrolling Container */}
        <div 
          className="flex gap-6 animate-scroll-left hover:pause-animation"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            animationPlayState: isHovered ? 'paused' : 'running'
          }}
        >
          {duplicatedSpecialties.map((specialty, index) => (
            <div
              key={index}
              className="flex-shrink-0 bg-white rounded-2xl p-6 shadow-[0_4px_20px_rgba(37,78,112,0.06)] border border-[#254e70]/5 hover:shadow-[0_8px_30px_rgba(37,78,112,0.12)] hover:-translate-y-1 transition-all duration-300 cursor-pointer group min-w-[280px] sm:min-w-[320px]"
            >
              {/* Icon and Title Row */}
              <div className="flex items-center gap-4 mb-3">
                <div className={`flex items-center justify-center w-12 h-12 ${specialty.color} rounded-xl text-white group-hover:scale-110 transition-transform duration-300`}>
                  {specialty.icon}
                </div>
                <h3 className="text-lg font-semibold text-[#254e70] group-hover:text-[#9dacff] transition-colors duration-300">
                  {specialty.title}
                </h3>
              </div>
              
              {/* Description */}
              <p className="text-sm text-[#254e70]/70 leading-relaxed">
                {specialty.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* CSS Animation Styles */}
      <style jsx>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll-left {
          animation: scroll-left 40s linear infinite;
        }
        
        .hover\\:pause-animation:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}

export default TherapySpecialtiesSection; 